import { getParamFromUrl } from "./global";
export const getIdFromTableRow = (row) => {
    if (row.classList.contains('no-items')) {
        return 0;
    }
    let item_id = getIdFromString(row.id);
    if (!item_id) {
        let input = row.querySelector('.check-column input[type=checkbox]');
        if (input) {
            item_id = getIdFromString(input.id);
        }
    }
    // Try to get the ID from the edit URL (MS Sites)
    if (!item_id) {
        let link = row.parentElement.querySelector('.edit a');
        if (link) {
            let href = link.getAttribute('href');
            if (href) {
                item_id = parseInt(getParamFromUrl('id', href));
            }
        }
    }
    row.dataset.id = item_id.toString();
    return item_id;
};
export const getIdFromString = (value) => {
    let id_parts = value.split(/[_,\-]+/);
    return parseInt(id_parts[id_parts.length - 1]);
};
export const getRowCellByName = (row, column_name) => {
    return row.querySelector(`td.column-${column_name}`);
};
export const resolveTableBySelector = (selector) => {
    let table = document.querySelector(selector);
    if (!table) {
        return null;
    }
    if (table.tagName === 'TABLE') {
        return table;
    }
    if (table.tagName === 'TBODY') {
        return table.closest('table');
    }
    if (table.querySelector('table.wp-list-table')) {
        return table.querySelector('table.wp-list-table');
    }
    return null;
};
